import axios from 'axios';
import { API_URL } from './api';

export const locationService = {
    list () {
        console.log('locationService: list');

        return axios
            .get(`${API_URL}/vestigingen`)
            .then((response) => {
                if (response.data.data)
                {
                    return response.data.data;
                }

                return response;
            });
    },

    create (formData) {
        console.log('locationService: create');

        return axios
            .post(`${API_URL}/vestigingen`, formData)
            .then((response) => response);
    },

    update (id, formData) {
        console.log('locationService: update');

        return axios
            .put(`${API_URL}/vestigingen/${id}`, formData)
            .then((response) => {
                if (response.data.data)
                {
                    return response.data.data;
                }

                return response;
            });
    },

    get (id) {
        console.log('locationService: getById', id);

        return axios
            .get(`${API_URL}/vestigingen/${id}`)
            .then((response) => {
                if (response.data.data && response.data.data[0])
                {
                    return response.data.data[0];
                }

                return response;
            });
    },
};

export default locationService;
